import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIranIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15606_135400)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9994 0.869141H0V7.80644H11.9994V0.869141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9994 5.5293H0V7.80784H11.9994V5.5293Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.93645 5.62305H2.2793V5.66862H2.93645V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.42412 5.84961H2.37891V5.89387H2.42412V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.93555 5.89518V5.84961H2.80421V5.89518H2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.05694 5.62305H3.01172V5.89621H3.05694V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.26953 5.89518V5.84961H3.02064V5.89518H3.26953Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 5.74414H2.80664V5.89626H2.85186V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.27959 5.62305H3.23438V5.89621H3.27959V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.16826 5.62305H3.12305V5.89621H3.16826V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.51953 5.778V5.73242H2.27968V5.778H2.51953Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.04688 5.778V5.73242H2.80702V5.778H3.04688Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 5.74414H2.80664V5.89626H2.85186V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 5.74414H2.80664V5.89626H2.85186V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 5.74414H2.80664V5.89626H2.85186V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.32451 5.74414H2.2793V5.89626H2.32451V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.71123 5.74414H2.66602V5.89626H2.71123V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.51787 5.74414H2.47266V5.89626H2.51787V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.69531 5.89518V5.84961H2.49256V5.89518H2.69531Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.71289 5.778V5.73242H2.58434V5.778H2.71289Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.85833 5.62305H1.20117V5.66862H1.85833V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.346 5.84961H1.30078V5.89387H1.346V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.85742 5.89518V5.84961H1.72609V5.89518H1.85742Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.97881 5.62305H1.93359V5.89621H1.97881V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.19141 5.89518V5.84961H1.94252V5.89518H2.19141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 5.74414H1.72852V5.89626H1.77373V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.20147 5.62305H2.15625V5.89621H2.20147V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.09014 5.62305H2.04492V5.89621H2.09014V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.44141 5.778V5.73242H1.20156V5.778H1.44141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.96875 5.778V5.73242H1.7289V5.778H1.96875Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 5.74414H1.72852V5.89626H1.77373V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 5.74414H1.72852V5.89626H1.77373V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 5.74414H1.72852V5.89626H1.77373V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.24639 5.74414H1.20117V5.89626H1.24639V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.63311 5.74414H1.58789V5.89626H1.63311V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.43975 5.74414H1.39453V5.89626H1.43975V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.61719 5.89518V5.84961H1.41444V5.89518H1.61719Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.63477 5.778V5.73242H1.50622V5.778H1.63477Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.00872 5.62305H3.35156V5.66862H4.00872V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.49639 5.84961H3.45117V5.89387H3.49639V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.00781 5.89518V5.84961H3.87648V5.89518H4.00781Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.1292 5.62305H4.08398V5.89621H4.1292V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.3418 5.89518V5.84961H4.09291V5.89518H4.3418Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 5.74414H3.87891V5.89626H3.92412V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.35186 5.62305H4.30664V5.89621H4.35186V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.24053 5.62305H4.19531V5.89621H4.24053V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.5918 5.778V5.73242H3.35195V5.778H3.5918Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.11914 5.778V5.73242H3.87929V5.778H4.11914Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 5.74414H3.87891V5.89626H3.92412V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 5.74414H3.87891V5.89626H3.92412V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 5.74414H3.87891V5.89626H3.92412V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.39678 5.74414H3.35156V5.89626H3.39678V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.7835 5.74414H3.73828V5.89626H3.7835V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.59014 5.74414H3.54492V5.89626H3.59014V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.76758 5.89518V5.84961H3.56483V5.89518H3.76758Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.78516 5.778V5.73242H3.65661V5.778H3.78516Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5673 5.62305H10.9102V5.66862H11.5673V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.055 5.84961H11.0098V5.89387H11.055V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5664 5.89518V5.84961H11.4351V5.89518H11.5664Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6878 5.62305H11.6426V5.89621H11.6878V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9004 5.89518V5.84961H11.6515V5.89518H11.9004Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 5.74414H11.4375V5.89626H11.4827V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9105 5.62305H11.8652V5.89621H11.9105V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7991 5.62305H11.7539V5.89621H11.7991V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1504 5.778V5.73242H10.9105V5.778H11.1504Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6777 5.778V5.73242H11.4379V5.778H11.6777Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 5.74414H11.4375V5.89626H11.4827V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 5.74414H11.4375V5.89626H11.4827V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 5.74414H11.4375V5.89626H11.4827V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9554 5.74414H10.9102V5.89626H10.9554V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3421 5.74414H11.2969V5.89626H11.3421V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1487 5.74414H11.1035V5.89626H11.1487V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3262 5.89518V5.84961H11.1234V5.89518H11.3262Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3438 5.778V5.73242H11.2152V5.778H11.3438Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.08684 5.62305H4.42969V5.66862H5.08684V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.57451 5.84961H4.5293V5.89387H4.57451V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.08594 5.89518V5.84961H4.9546V5.89518H5.08594Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.20733 5.62305H5.16211V5.89621H5.20733V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.41992 5.89518V5.84961H5.17103V5.89518H5.41992Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 5.74414H4.95703V5.89626H5.00225V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.42998 5.62305H5.38477V5.89621H5.42998V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.31865 5.62305H5.27344V5.89621H5.31865V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66992 5.778V5.73242H4.43007V5.778H4.66992Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.19727 5.778V5.73242H4.95741V5.778H5.19727Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 5.74414H4.95703V5.89626H5.00225V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 5.74414H4.95703V5.89626H5.00225V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 5.74414H4.95703V5.89626H5.00225V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.4749 5.74414H4.42969V5.89626H4.4749V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.86162 5.74414H4.81641V5.89626H4.86162V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66826 5.74414H4.62305V5.89626H4.66826V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.8457 5.89518V5.84961H4.64295V5.89518H4.8457Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.86328 5.778V5.73242H4.73473V5.778H4.86328Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.16497 5.62305H5.50781V5.66862H6.16497V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.65264 5.84961H5.60742V5.89387H5.65264V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.16406 5.89518V5.84961H6.03273V5.89518H6.16406Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.28545 5.62305H6.24023V5.89621H6.28545V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.49805 5.89518V5.84961H6.24916V5.89518H6.49805Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 5.74414H6.03516V5.89626H6.08037V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.50811 5.62305H6.46289V5.89621H6.50811V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.39678 5.62305H6.35156V5.89621H6.39678V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.74805 5.778V5.73242H5.5082V5.778H5.74805Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.27539 5.778V5.73242H6.03554V5.778H6.27539Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 5.74414H6.03516V5.89626H6.08037V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 5.74414H6.03516V5.89626H6.08037V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 5.74414H6.03516V5.89626H6.08037V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.55303 5.74414H5.50781V5.89626H5.55303V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.93975 5.74414H5.89453V5.89626H5.93975V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.74639 5.74414H5.70117V5.89626H5.74639V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.92383 5.89518V5.84961H5.72108V5.89518H5.92383Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.94141 5.778V5.73242H5.81286V5.778H5.94141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9994 0.869141H0V3.14768H11.9994V0.869141Z",
				fill: "#239F40"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.25481 5.62305H6.59766V5.66862H7.25481V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.74248 5.84961H6.69727V5.89387H6.74248V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.25391 5.89518V5.84961H7.12257V5.89518H7.25391Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.37529 5.62305H7.33008V5.89621H7.37529V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.58789 5.89518V5.84961H7.339V5.89518H7.58789Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 5.74414H7.125V5.89626H7.17022V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.59795 5.62305H7.55273V5.89621H7.59795V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.48662 5.62305H7.44141V5.89621H7.48662V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.83789 5.778V5.73242H6.59804V5.778H6.83789Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.36523 5.778V5.73242H7.12538V5.778H7.36523Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 5.74414H7.125V5.89626H7.17022V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 5.74414H7.125V5.89626H7.17022V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 5.74414H7.125V5.89626H7.17022V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.64287 5.74414H6.59766V5.89626H6.64287V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.02959 5.74414H6.98438V5.89626H7.02959V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.83623 5.74414H6.79102V5.89626H6.83623V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.01367 5.89518V5.84961H6.81092V5.89518H7.01367Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.03125 5.778V5.73242H6.9027V5.778H7.03125Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.33879 5.62305H7.68164V5.66862H8.33879V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82647 5.84961H7.78125V5.89387H7.82647V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.33789 5.89518V5.84961H8.20656V5.89518H8.33789Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.45928 5.62305H8.41406V5.89621H8.45928V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.67188 5.89518V5.84961H8.42299V5.89518H8.67188Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 5.74414H8.20898V5.89626H8.2542V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.68194 5.62305H8.63672V5.89621H8.68194V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.57061 5.62305H8.52539V5.89621H8.57061V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.92188 5.778V5.73242H7.68202V5.778H7.92188Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.44922 5.778V5.73242H8.20937V5.778H8.44922Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 5.74414H8.20898V5.89626H8.2542V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 5.74414H8.20898V5.89626H8.2542V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 5.74414H8.20898V5.89626H8.2542V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.72686 5.74414H7.68164V5.89626H7.72686V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.11358 5.74414H8.06836V5.89626H8.11358V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.92022 5.74414H7.875V5.89626H7.92022V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.09766 5.89518V5.84961H7.89491V5.89518H8.09766Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.11523 5.778V5.73242H7.98669V5.778H8.11523Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.41692 5.62305H8.75977V5.66862H9.41692V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.90459 5.84961H8.85938V5.89387H8.90459V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.41602 5.89518V5.84961H9.28468V5.89518H9.41602Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.5374 5.62305H9.49219V5.89621H9.5374V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.75 5.89518V5.84961H9.50111V5.89518H9.75Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 5.74414H9.28711V5.89626H9.33233V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.76006 5.62305H9.71484V5.89621H9.76006V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.64873 5.62305H9.60352V5.89621H9.64873V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 5.778V5.73242H8.76015V5.778H9Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.52734 5.778V5.73242H9.28749V5.778H9.52734Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 5.74414H9.28711V5.89626H9.33233V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 5.74414H9.28711V5.89626H9.33233V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 5.74414H9.28711V5.89626H9.33233V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.80498 5.74414H8.75977V5.89626H8.80498V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.1917 5.74414H9.14648V5.89626H9.1917V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.99834 5.74414H8.95312V5.89626H8.99834V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.17578 5.89518V5.84961H8.97303V5.89518H9.17578Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.19336 5.778V5.73242H9.06481V5.778H9.19336Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5068 5.62305H9.84961V5.66862H10.5068V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.99444 5.84961H9.94922V5.89387H9.99444V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5059 5.89518V5.84961H10.3745V5.89518H10.5059Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6272 5.62305H10.582V5.89621H10.6272V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8398 5.89518V5.84961H10.591V5.89518H10.8398Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 5.74414H10.377V5.89626H10.4222V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8499 5.62305H10.8047V5.89621H10.8499V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.7386 5.62305H10.6934V5.89621H10.7386V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0898 5.778V5.73242H9.84999V5.778H10.0898Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6172 5.778V5.73242H10.3773V5.778H10.6172Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 5.74414H10.377V5.89626H10.4222V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 5.74414H10.377V5.89626H10.4222V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 5.74414H10.377V5.89626H10.4222V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.89483 5.74414H9.84961V5.89626H9.89483V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2815 5.74414H10.2363V5.89626H10.2815V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0882 5.74414H10.043V5.89626H10.0882V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2656 5.89518V5.84961H10.0629V5.89518H10.2656Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2832 5.778V5.73242H10.1547V5.778H10.2832Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.768482 5.62305H0.111328V5.66862H0.768482V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.256154 5.84961H0.210938V5.89387H0.256154V5.84961Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.767578 5.89518V5.84961H0.636245V5.89518H0.767578Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.888966 5.62305H0.84375V5.89621H0.888966V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.10156 5.89518V5.84961H0.852675V5.89518H1.10156Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 5.74414H0.638672V5.89626H0.683888V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.11162 5.62305H1.06641V5.89621H1.11162V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.00029 5.62305H0.955078V5.89621H1.00029V5.62305Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.351562 5.778V5.73242H0.111711V5.778H0.351562Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.878906 5.778V5.73242H0.639055V5.778H0.878906Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 5.74414H0.638672V5.89626H0.683888V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 5.74414H0.638672V5.89626H0.683888V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 5.74414H0.638672V5.89626H0.683888V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.156545 5.74414H0.111328V5.89626H0.156545V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.543263 5.74414H0.498047V5.89626H0.543263V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.349904 5.74414H0.304688V5.89626H0.349904V5.74414Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.527344 5.89518V5.84961H0.324593V5.89518H0.527344Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.544922 5.778V5.73242H0.416375V5.778H0.544922Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.93645 2.81445H2.2793V2.86003H2.93645V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.42412 3.04102H2.37891V3.08527H2.42412V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.93555 3.08659V3.04102H2.80421V3.08659H2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.05694 2.81445H3.01172V3.08762H3.05694V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.26953 3.08659V3.04102H3.02064V3.08659H3.26953Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 2.93555H2.80664V3.08767H2.85186V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.27959 2.81445H3.23438V3.08762H3.27959V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.16826 2.81445H3.12305V3.08762H3.16826V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.51953 2.9694V2.92383H2.27968V2.9694H2.51953Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.04688 2.9694V2.92383H2.80702V2.9694H3.04688Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 2.93555H2.80664V3.08767H2.85186V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 2.93555H2.80664V3.08767H2.85186V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.85186 2.93555H2.80664V3.08767H2.85186V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.32451 2.93555H2.2793V3.08767H2.32451V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.71123 2.93555H2.66602V3.08767H2.71123V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.51787 2.93555H2.47266V3.08767H2.51787V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.69531 3.08659V3.04102H2.49256V3.08659H2.69531Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.71289 2.9694V2.92383H2.58434V2.9694H2.71289Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.85833 2.81445H1.20117V2.86003H1.85833V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.346 3.04102H1.30078V3.08527H1.346V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.85742 3.08659V3.04102H1.72609V3.08659H1.85742Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.97881 2.81445H1.93359V3.08762H1.97881V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.19141 3.08659V3.04102H1.94252V3.08659H2.19141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 2.93555H1.72852V3.08767H1.77373V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.20147 2.81445H2.15625V3.08762H2.20147V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.09014 2.81445H2.04492V3.08762H2.09014V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.44141 2.9694V2.92383H1.20156V2.9694H1.44141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.96875 2.9694V2.92383H1.7289V2.9694H1.96875Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 2.93555H1.72852V3.08767H1.77373V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 2.93555H1.72852V3.08767H1.77373V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.77373 2.93555H1.72852V3.08767H1.77373V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.24639 2.93555H1.20117V3.08767H1.24639V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.63311 2.93555H1.58789V3.08767H1.63311V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.43975 2.93555H1.39453V3.08767H1.43975V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.61719 3.08659V3.04102H1.41444V3.08659H1.61719Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.63477 2.9694V2.92383H1.50622V2.9694H1.63477Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.00872 2.81445H3.35156V2.86003H4.00872V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.49639 3.04102H3.45117V3.08527H3.49639V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.00781 3.08659V3.04102H3.87648V3.08659H4.00781Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.1292 2.81445H4.08398V3.08762H4.1292V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.3418 3.08659V3.04102H4.09291V3.08659H4.3418Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 2.93555H3.87891V3.08767H3.92412V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.35186 2.81445H4.30664V3.08762H4.35186V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.24053 2.81445H4.19531V3.08762H4.24053V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.5918 2.9694V2.92383H3.35195V2.9694H3.5918Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.11914 2.9694V2.92383H3.87929V2.9694H4.11914Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 2.93555H3.87891V3.08767H3.92412V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 2.93555H3.87891V3.08767H3.92412V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.92412 2.93555H3.87891V3.08767H3.92412V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.39678 2.93555H3.35156V3.08767H3.39678V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.7835 2.93555H3.73828V3.08767H3.7835V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.59014 2.93555H3.54492V3.08767H3.59014V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.76758 3.08659V3.04102H3.56483V3.08659H3.76758Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.78516 2.9694V2.92383H3.65661V2.9694H3.78516Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5673 2.81445H10.9102V2.86003H11.5673V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.055 3.04102H11.0098V3.08527H11.055V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.5664 3.08659V3.04102H11.4351V3.08659H11.5664Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6878 2.81445H11.6426V3.08762H11.6878V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9004 3.08659V3.04102H11.6515V3.08659H11.9004Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 2.93555H11.4375V3.08767H11.4827V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9105 2.81445H11.8652V3.08762H11.9105V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7991 2.81445H11.7539V3.08762H11.7991V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1504 2.9694V2.92383H10.9105V2.9694H11.1504Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.6777 2.9694V2.92383H11.4379V2.9694H11.6777Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 2.93555H11.4375V3.08767H11.4827V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 2.93555H11.4375V3.08767H11.4827V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4827 2.93555H11.4375V3.08767H11.4827V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9554 2.93555H10.9102V3.08767H10.9554V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3421 2.93555H11.2969V3.08767H11.3421V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1487 2.93555H11.1035V3.08767H11.1487V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3262 3.08659V3.04102H11.1234V3.08659H11.3262Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3438 2.9694V2.92383H11.2152V2.9694H11.3438Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.08684 2.81445H4.42969V2.86003H5.08684V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.57451 3.04102H4.5293V3.08527H4.57451V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.08594 3.08659V3.04102H4.9546V3.08659H5.08594Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.20733 2.81445H5.16211V3.08762H5.20733V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.41992 3.08659V3.04102H5.17103V3.08659H5.41992Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 2.93555H4.95703V3.08767H5.00225V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.42998 2.81445H5.38477V3.08762H5.42998V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.31865 2.81445H5.27344V3.08762H5.31865V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66992 2.9694V2.92383H4.43007V2.9694H4.66992Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.19727 2.9694V2.92383H4.95741V2.9694H5.19727Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 2.93555H4.95703V3.08767H5.00225V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 2.93555H4.95703V3.08767H5.00225V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00225 2.93555H4.95703V3.08767H5.00225V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.4749 2.93555H4.42969V3.08767H4.4749V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.86162 2.93555H4.81641V3.08767H4.86162V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66826 2.93555H4.62305V3.08767H4.66826V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.8457 3.08659V3.04102H4.64295V3.08659H4.8457Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.86328 2.9694V2.92383H4.73473V2.9694H4.86328Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.16497 2.81445H5.50781V2.86003H6.16497V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.65264 3.04102H5.60742V3.08527H5.65264V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.16406 3.08659V3.04102H6.03273V3.08659H6.16406Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.28545 2.81445H6.24023V3.08762H6.28545V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.49805 3.08659V3.04102H6.24916V3.08659H6.49805Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 2.93555H6.03516V3.08767H6.08037V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.50811 2.81445H6.46289V3.08762H6.50811V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.39678 2.81445H6.35156V3.08762H6.39678V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.74805 2.9694V2.92383H5.5082V2.9694H5.74805Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.27539 2.9694V2.92383H6.03554V2.9694H6.27539Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 2.93555H6.03516V3.08767H6.08037V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 2.93555H6.03516V3.08767H6.08037V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.08037 2.93555H6.03516V3.08767H6.08037V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.55303 2.93555H5.50781V3.08767H5.55303V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.93975 2.93555H5.89453V3.08767H5.93975V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.74639 2.93555H5.70117V3.08767H5.74639V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.92383 3.08659V3.04102H5.72108V3.08659H5.92383Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.94141 2.9694V2.92383H5.81286V2.9694H5.94141Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.25481 2.81445H6.59766V2.86003H7.25481V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.74248 3.04102H6.69727V3.08527H6.74248V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.25391 3.08659V3.04102H7.12257V3.08659H7.25391Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.37529 2.81445H7.33008V3.08762H7.37529V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.58789 3.08659V3.04102H7.339V3.08659H7.58789Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 2.93555H7.125V3.08767H7.17022V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.59795 2.81445H7.55273V3.08762H7.59795V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.48662 2.81445H7.44141V3.08762H7.48662V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.83789 2.9694V2.92383H6.59804V2.9694H6.83789Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.36523 2.9694V2.92383H7.12538V2.9694H7.36523Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 2.93555H7.125V3.08767H7.17022V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 2.93555H7.125V3.08767H7.17022V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.17022 2.93555H7.125V3.08767H7.17022V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.64287 2.93555H6.59766V3.08767H6.64287V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.02959 2.93555H6.98438V3.08767H7.02959V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.83623 2.93555H6.79102V3.08767H6.83623V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.01367 3.08659V3.04102H6.81092V3.08659H7.01367Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.03125 2.9694V2.92383H6.9027V2.9694H7.03125Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.33879 2.81445H7.68164V2.86003H8.33879V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.82647 3.04102H7.78125V3.08527H7.82647V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.33789 3.08659V3.04102H8.20656V3.08659H8.33789Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.45928 2.81445H8.41406V3.08762H8.45928V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.67188 3.08659V3.04102H8.42299V3.08659H8.67188Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 2.93555H8.20898V3.08767H8.2542V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.68194 2.81445H8.63672V3.08762H8.68194V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.57061 2.81445H8.52539V3.08762H8.57061V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.92188 2.9694V2.92383H7.68202V2.9694H7.92188Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.44922 2.9694V2.92383H8.20937V2.9694H8.44922Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 2.93555H8.20898V3.08767H8.2542V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 2.93555H8.20898V3.08767H8.2542V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.2542 2.93555H8.20898V3.08767H8.2542V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.72686 2.93555H7.68164V3.08767H7.72686V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.11358 2.93555H8.06836V3.08767H8.11358V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.92022 2.93555H7.875V3.08767H7.92022V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.09766 3.08659V3.04102H7.89491V3.08659H8.09766Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.11523 2.9694V2.92383H7.98669V2.9694H8.11523Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.41692 2.81445H8.75977V2.86003H9.41692V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.90459 3.04102H8.85938V3.08527H8.90459V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.41602 3.08659V3.04102H9.28468V3.08659H9.41602Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.5374 2.81445H9.49219V3.08762H9.5374V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.75 3.08659V3.04102H9.50111V3.08659H9.75Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 2.93555H9.28711V3.08767H9.33233V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.76006 2.81445H9.71484V3.08762H9.76006V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.64873 2.81445H9.60352V3.08762H9.64873V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 2.9694V2.92383H8.76015V2.9694H9Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.52734 2.9694V2.92383H9.28749V2.9694H9.52734Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 2.93555H9.28711V3.08767H9.33233V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 2.93555H9.28711V3.08767H9.33233V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33233 2.93555H9.28711V3.08767H9.33233V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.80498 2.93555H8.75977V3.08767H8.80498V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.1917 2.93555H9.14648V3.08767H9.1917V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.99834 2.93555H8.95312V3.08767H8.99834V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.17578 3.08659V3.04102H8.97303V3.08659H9.17578Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.19336 2.9694V2.92383H9.06481V2.9694H9.19336Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5068 2.81445H9.84961V2.86003H10.5068V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.99444 3.04102H9.94922V3.08527H9.99444V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.5059 3.08659V3.04102H10.3745V3.08659H10.5059Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6272 2.81445H10.582V3.08762H10.6272V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8398 3.08659V3.04102H10.591V3.08659H10.8398Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 2.93555H10.377V3.08767H10.4222V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8499 2.81445H10.8047V3.08762H10.8499V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.7386 2.81445H10.6934V3.08762H10.7386V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0898 2.9694V2.92383H9.84999V2.9694H10.0898Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6172 2.9694V2.92383H10.3773V2.9694H10.6172Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 2.93555H10.377V3.08767H10.4222V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 2.93555H10.377V3.08767H10.4222V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4222 2.93555H10.377V3.08767H10.4222V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.89483 2.93555H9.84961V3.08767H9.89483V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2815 2.93555H10.2363V3.08767H10.2815V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0882 2.93555H10.043V3.08767H10.0882V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2656 3.08659V3.04102H10.0629V3.08659H10.2656Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2832 2.9694V2.92383H10.1547V2.9694H10.2832Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.768482 2.81445H0.111328V2.86003H0.768482V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.256154 3.04102H0.210938V3.08527H0.256154V3.04102Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.767578 3.08659V3.04102H0.636245V3.08659H0.767578Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.888966 2.81445H0.84375V3.08762H0.888966V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.10156 3.08659V3.04102H0.852675V3.08659H1.10156Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 2.93555H0.638672V3.08767H0.683888V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.11162 2.81445H1.06641V3.08762H1.11162V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.00029 2.81445H0.955078V3.08762H1.00029V2.81445Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.351562 2.9694V2.92383H0.111711V2.9694H0.351562Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.878906 2.9694V2.92383H0.639055V2.9694H0.878906Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 2.93555H0.638672V3.08767H0.683888V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 2.93555H0.638672V3.08767H0.683888V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683888 2.93555H0.638672V3.08767H0.683888V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.156545 2.93555H0.111328V3.08767H0.156545V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.543263 2.93555H0.498047V3.08767H0.543263V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.349904 2.93555H0.304688V3.08767H0.349904V2.93555Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.527344 3.08659V3.04102H0.324593V3.08659H0.527344Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.544922 2.9694V2.92383H0.416375V2.9694H0.544922Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.73334 5.46875H1.65234V5.61055H1.73334V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.87788 5.46875H3.79688V5.61055H3.87788V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.0810012 5.46875H0V5.61055H0.0810012V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.17084 5.46875H1.08984V5.61055H1.17084V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.25483 5.46875H2.17383V5.61055H2.25483V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.79389 5.46875H2.71289V5.61055H2.79389V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33881 5.46875H3.25781V5.61055H3.33881V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.41694 5.46875H4.33594V5.61055H4.41694V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.13569 5.46875H7.05469V5.61055H7.13569V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.96186 5.46875H4.88086V5.61055H4.96186V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.50092 5.46875H5.41992V5.61055H5.50092V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.03999 5.46875H5.95898V5.61055H6.03999V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.58491 5.46875H6.50391V5.61055H6.58491V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9091 5.46875H10.8281V5.61055H10.9091V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.66303 5.46875H7.58203V5.61055H7.66303V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.20795 5.46875H8.12695V5.61055H8.20795V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.75874 5.46875H8.67773V5.61055H8.75874V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.28022 5.46875H9.19922V5.61055H9.28022V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.831 5.46875H9.75V5.61055H9.831V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3759 5.46875H10.2949V5.61055H10.3759V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9755 5.46875H11.8945V5.61055H11.9755V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4599 5.46875H11.3789V5.61055H11.4599V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.625923 5.46875H0.544922V5.61055H0.625923V5.46875Z",
				fill: "#D90000"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.73334 3.07031H1.65234V3.21211H1.73334V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.87788 3.07031H3.79688V3.21211H3.87788V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.0810012 3.07031H0V3.21211H0.0810012V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.17084 3.07031H1.08984V3.21211H1.17084V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.25483 3.07031H2.17383V3.21211H2.25483V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.79389 3.07031H2.71289V3.21211H2.79389V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33881 3.07031H3.25781V3.21211H3.33881V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.41694 3.07031H4.33594V3.21211H4.41694V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.13569 3.07031H7.05469V3.21211H7.13569V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.96186 3.07031H4.88086V3.21211H4.96186V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.50092 3.07031H5.41992V3.21211H5.50092V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.03999 3.07031H5.95898V3.21211H6.03999V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.58491 3.07031H6.50391V3.21211H6.58491V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9091 3.07031H10.8281V3.21211H10.9091V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.66303 3.07031H7.58203V3.21211H7.66303V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.20795 3.07031H8.12695V3.21211H8.20795V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.75874 3.07031H8.67773V3.21211H8.75874V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.28022 3.07031H9.19922V3.21211H9.28022V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.831 3.07031H9.75V3.21211H9.831V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3759 3.07031H10.2949V3.21211H10.3759V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9755 3.07031H11.8945V3.21211H11.9755V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4599 3.07031H11.3789V3.21211H11.4599V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.625923 3.07031H0.544922V3.21211H0.625923V3.07031Z",
				fill: "#239E3F"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.31989 3.54492C6.43309 3.68533 6.78211 4.46162 6.10923 4.97011C5.79297 5.21093 5.98884 5.2231 5.9981 5.26365C6.50663 4.99039 6.67264 4.62021 6.66876 4.28849C6.66489 3.95691 6.49115 3.66379 6.31989 3.54492Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.38672 3.50977C6.63787 3.63982 7.18428 4.29403 6.59613 5.03201C6.9616 4.94992 7.42617 3.86106 6.38672 3.50977Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.61622 3.50977C5.36507 3.63982 4.81867 4.29403 5.40681 5.03201C5.04135 4.94992 4.57677 3.86106 5.61622 3.50977Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.68098 3.54492C5.56777 3.68533 5.21875 4.46162 5.89163 4.97011C6.20803 5.21093 6.01216 5.2231 6.00276 5.26365C5.49437 4.99039 5.32823 4.62021 5.3321 4.28849C5.33597 3.95691 5.50972 3.66379 5.68098 3.54492Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.64783 5.19347C6.44879 5.19653 6.19791 5.16574 6.01172 5.06836C6.0424 5.12841 6.06784 5.16616 6.09852 5.22621C6.276 5.24279 6.52094 5.26313 6.64783 5.19347Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.37305 5.19347C5.57195 5.19653 5.82283 5.16574 6.00888 5.06836C5.97833 5.12841 5.9529 5.16616 5.92221 5.22621C5.74473 5.24279 5.49994 5.26313 5.37305 5.19347Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.74141 3.31445C5.78178 3.42242 5.88752 3.43817 6.00072 3.3745C6.08324 3.42451 6.21096 3.42758 6.25492 3.31961C6.28837 3.58668 6.00971 3.52357 5.99934 3.47133C5.89567 3.57233 5.70257 3.51396 5.74141 3.31445Z",
				fill: "#DA0000"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.00647 5.36026L6.11111 5.23929L6.12603 3.6109L6.00149 3.5L5.87695 3.60586L5.90183 5.24432L6.00647 5.36026Z",
				fill: "#DA0000"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15606_135400",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 6.9373,
			fill: "white",
			transform: "translate(0 0.869141)"
		})
	}) })]
});
export default SvgIranIcon;
